import { cacheDom } from "../utils/QuerySelectors.js"
import { makeRequest, makeProduct } from "../utils/Storefront.js"

const dom = {}
const qs = {
  tabTitle: 'data-tab-title',
}
const qsAll = {
  sections: 'data-section-type="four-up-products"',
  triggers: 'data-trigger',
  tabs: 'data-tab',
}

const initSwipers = (tabs) => {
  const stack = tabs[0]?.dataset.stack == 'true'
  if(window.innerWidth >= 1024 || !stack) {
    tabs.forEach(tab => {
      if((typeof tab.swiper == 'undefined') || !tab.swiper) {
        new Swiper(tab, {
          slidesPerView: 2,
          slidesPerGroup: 2,
          breakpoints: {
            300: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            1024: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
      }
    })
  } else {
    tabs.forEach(tab => {
      if((typeof tab.swiper != 'undefined') && tab.swiper) tab.swiper.destroy(true, true)
    })
  }
}

// const iObserver = new IntersectionObserver(items => {
//   if (items[0].isIntersecting) {
//     const section = items[0].target
//     if(!section.dataset.inited) {
//       section.dataset.inited = true
//       const slides = section.querySelectorAll(`[data-slide-item]`)
//       // slides.forEach(slide => {
//       //   // const json = JSON.parse(slide.getAttribute('json'))
//       //   // const tile = document.createElement('div')
//       //   // tile.setAttribute('product-tile', json.id)
//       //   // tile.setAttribute('json', slide.getAttribute('json'))
//       //   // tile.setAttribute('lazyload', slide.closest(`[${qsAll.tabs}]`).dataset.lazyload)
//       //   // slide.appendChild(tile)
//       // })

//       const ids = Array.from(slides).map(slide => `"gid://shopify/Product/${slide.dataset.slideItem}"`)
//       const query = `{
//         nodes(ids: [${ids.join(',')}]) {
//           ...on Product {
//             ${window.productResponse}
//           }
//         }
//       }`
//       makeRequest(
//         (results) => {
//           console.log(results)
//           results.data.nodes.forEach(node => {
//             const json = makeProduct(node)
//             const slide = section.querySelector(`[data-slide-item="${json.id}"]`)
//             const tile = document.createElement('div')
//             tile.setAttribute('product-tile', json.id)
//             tile.setAttribute('json', JSON.stringify(json))
//             tile.setAttribute('lazyload', slide.closest(`[${qsAll.tabs}]`).dataset.lazyload)
//             slide.appendChild(tile)
//           })
//           window.setupProductTiles(section.querySelectorAll('[product-tile]:empty'))
//         },
//         query
//       )
//     }
//   }
// })

const initSection = (section) => {
  // iObserver.observe(section)
  
  const slides = section.querySelectorAll(`[data-slide-item]`)

  const ids = Array.from(slides).map(slide => `"gid://shopify/Product/${slide.dataset.slideItem}"`)
  const query = `{
    nodes(ids: [${ids.join(',')}]) {
      ...on Product {
        ${window.basicProductResponse}
      }
    }
  }`
  makeRequest(
    (results) => {
      console.log(results)
      results.data.nodes.forEach(node => {
        const json = makeProduct(node)
        const slides = section.querySelectorAll(`[data-slide-item="${json.id}"]`)
        slides.forEach(slide => {
          const tile = document.createElement('div')
          if(!slide.querySelector(`[product-tile="${json.id}"]`)) {
            json.collectionLoaded = false
            tile.setAttribute('product-tile', json.id)
            tile.setAttribute('json', JSON.stringify(json))
            tile.setAttribute('lazyload', slide.closest(`[${qsAll.tabs}]`).dataset.lazyload)
            tile.setAttribute('columns_desktop', 4)
            tile.setAttribute('columns_tablet', 2)
            tile.setAttribute('columns_mobile', 1.4)
            tile.setAttribute('real_price', slide.getAttribute('data-real-price'))
            tile.setAttribute('real_comp_price', slide.getAttribute('data-real-comp-price'))
            slide.appendChild(tile)
          }
        })
      })
      window.setupProductTiles(section.querySelectorAll('[product-tile]:empty'))
      setTimeout(() => {
        const sectionId = section.dataset.sectionId
        window._swat.initializeActionButtons(`.section-${sectionId}`, '.plp-wishlist-btn')
      }, 1500)
    },
    query
  )
  
  const triggers = section.querySelectorAll(`[${qsAll.triggers}]`)
  const tabs = section.querySelectorAll(`[${qsAll.tabs}]`)
  const tabTitle = section.querySelector(`[${qs.tabTitle}]`)
  
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const url = trigger.dataset.trigger
      const handle = trigger.dataset.triggerHandle
      triggers.forEach(t => t.classList.toggle('four-up-products--trigger__active', t == trigger))
      tabs.forEach(t => t.classList.toggle('four-up-products--tab__active', t.dataset.tab == handle))
      if(typeof url != 'undefined' && url != '') {
        if(tabTitle) tabTitle.innerHTML = trigger.innerHTML
      }
    })
  })
  initSwipers(tabs)
  window.addEventListener('resize', () => {
    initSwipers(tabs)
  })
}

export const setupFourUpTabs = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}